import { getLocales } from '../../../locales/Locale';
import { sqmCalculationForNonStandardSpaces } from '../../../utils/Calculations';
import {
  APARTMENT_GROUP,
  BUILDING,
  TYPE_OF_SPACES,
} from '../../../utils/Constants';
import { fetchSheetData } from '../../../utils/fetchSheetData';

const { lang } = getLocales();

// Utility to dynamically import images and documents
const importAssets = (context: __WebpackModuleApi.RequireContext) =>
  context.keys().map((key) => ({
    path: context(key),
    name: key.replace('./', ''),
  }));

const apartmentsImgsList = importAssets(
  require.context('../../../assets/imgs/inProgress/apartments', true)
);

const apartmentsSituationImgsList = importAssets(
  require.context('../../../assets/imgs/inProgress/aparmtentSituation', true)
);

const apartmentsDocumentsList = importAssets(
  require.context('../../../assets/documents/inProgressPage', true)
);

//#region APARTMENTS TYPE

//#region A
const A_STUDIO: LocationAndType = {
  building: BUILDING.A,
  name: lang.apartments.name.studio,
};

const A_ONE: LocationAndType = {
  building: BUILDING.A,
  name: lang.apartments.name.one,
};

const A_TWO: LocationAndType = {
  building: BUILDING.A,
  name: lang.apartments.name.two,
};

const A_THRE: LocationAndType = {
  building: BUILDING.A,
  name: lang.apartments.name.three,
};
//#endregion

//#region B
const B_BP: LocationAndType = {
  building: BUILDING.B,
  name: lang.apartments.name.bp,
};

const B_STUDIO: LocationAndType = {
  building: BUILDING.B,
  name: lang.apartments.name.studio,
};

const B_ONE: LocationAndType = {
  building: BUILDING.B,
  name: lang.apartments.name.one,
};

const B_TWO: LocationAndType = {
  building: BUILDING.B,
  name: lang.apartments.name.two,
};
//#endregion

//#region C
const C_BP: LocationAndType = {
  building: BUILDING.C,
  name: lang.apartments.name.bp,
};

const C_ONE: LocationAndType = {
  building: BUILDING.C,
  name: lang.apartments.name.one,
};

const C_TWO: LocationAndType = {
  building: BUILDING.C,
  name: lang.apartments.name.two,
};
//#endregion

//#endregion

//#region GROUND

//#region A
const A01: Apartment = {
  ...A_ONE,
  apartmentNumber: '01',
  floor: APARTMENT_GROUP.GROUND,
  entrance: 2.8,
  kitchen: 3.4,
  livingRoom: 9.7,
  roomOne: 9.1,
  bathroom: 4.5,
  terrace: sqmCalculationForNonStandardSpaces(1.6, TYPE_OF_SPACES.TERRACE),
  garden: sqmCalculationForNonStandardSpaces(42.9, TYPE_OF_SPACES.GARDEN),
};

const A02: Apartment = {
  ...A_TWO,
  apartmentNumber: '02',
  floor: APARTMENT_GROUP.GROUND,
  entrance: 2.9,
  hallway: 4.3,
  kitchen: 3.6,
  livingRoom: 17.4,
  roomOne: 10.2,
  roomTwo: 10.8,
  bathroom: 4.4,
  wc: 1.8,
  storageRoom: 1.9,
  garden: sqmCalculationForNonStandardSpaces(50.1, TYPE_OF_SPACES.GARDEN),
};

const A03: Apartment = {
  ...A_STUDIO,
  apartmentNumber: '03',
  floor: APARTMENT_GROUP.GROUND,
  entrance: 2.8,
  kitchen: 7.1,
  livingRoom: 7.8,
  bathroom: 3.6,
  garden: sqmCalculationForNonStandardSpaces(6.3, TYPE_OF_SPACES.GARDEN),
};

const A04: Apartment = {
  ...A_ONE,
  apartmentNumber: '04',
  floor: APARTMENT_GROUP.GROUND,
  entrance: 2.6,
  kitchen: 3.5,
  livingRoom: 17.5,
  roomOne: 10.4,
  bathroom: 3.8,
  garden: sqmCalculationForNonStandardSpaces(11.4, TYPE_OF_SPACES.GARDEN),
};

const A05: Apartment = {
  ...A_ONE,
  apartmentNumber: '05',
  floor: APARTMENT_GROUP.GROUND,
  entrance: 3.6,
  kitchen: 3.5,
  livingRoom: 12.9,
  roomOne: 9.9,
  bathroom: 4.6,
  garden: sqmCalculationForNonStandardSpaces(22, TYPE_OF_SPACES.GARDEN),
};

const A06: Apartment = {
  ...A_ONE,
  apartmentNumber: '06',
  floor: APARTMENT_GROUP.GROUND,
  entrance: 3.6,
  kitchen: 3.5,
  livingRoom: 13.1,
  roomOne: 9.9,
  bathroom: 4.6,
  garden: sqmCalculationForNonStandardSpaces(22, TYPE_OF_SPACES.GARDEN),
};

const A07: Apartment = {
  ...A_ONE,
  apartmentNumber: '07',
  floor: APARTMENT_GROUP.GROUND,
  entrance: 2.7,
  kitchen: 3.6,
  livingRoom: 17.7,
  roomOne: 10.4,
  bathroom: 3.9,
  garden: sqmCalculationForNonStandardSpaces(11.4, TYPE_OF_SPACES.GARDEN),
};

const A08: Apartment = {
  ...A_STUDIO,
  apartmentNumber: '08',
  floor: APARTMENT_GROUP.GROUND,
  entrance: 2.8,
  kitchen: 7.1,
  livingRoom: 7.8,
  bathroom: 3.8,
  garden: sqmCalculationForNonStandardSpaces(6.3, TYPE_OF_SPACES.GARDEN),
};

const A09: Apartment = {
  ...A_TWO,
  apartmentNumber: '09',
  floor: APARTMENT_GROUP.GROUND,
  entrance: 2.7,
  foyer: 2.9,
  kitchen: 3.6,
  livingRoom: 17.7,
  roomOne: 10.5,
  roomTwo: 7.6,
  bathroom: 3.7,
  garden: sqmCalculationForNonStandardSpaces(15.7, TYPE_OF_SPACES.GARDEN),
};

const A10: Apartment = {
  ...A_THRE,
  apartmentNumber: '10',
  floor: APARTMENT_GROUP.GROUND,
  entrance: 3.2,
  kitchen: 4.7,
  livingRoom: 20.3,
  hallway: 2.2,
  roomOne: 10.5,
  roomTwo: 10,
  roomThree: 8.6,
  bathroom: 3.7,
  wc: 2.8,
  garden: sqmCalculationForNonStandardSpaces(35.7, TYPE_OF_SPACES.GARDEN),
};

const A11: Apartment = {
  ...A_TWO,
  apartmentNumber: '11',
  floor: APARTMENT_GROUP.GROUND,
  entrance: 5.2,
  kitchen: 3.5,
  livingRoom: 10.8,
  roomOne: 9.9,
  roomTwo: 5.6,
  bathroom: 4.5,
  garden: sqmCalculationForNonStandardSpaces(69.3, TYPE_OF_SPACES.GARDEN),
};
//#endregion

//#region B
const B01: Apartment = {
  ...B_BP,
  apartmentNumber: '01',
  floor: APARTMENT_GROUP.GROUND,
  bp: true,
  livingRoom: 40.4,
};

const B02: Apartment = {
  ...B_ONE,
  apartmentNumber: '02',
  floor: APARTMENT_GROUP.GROUND,
  entrance: 2.6,
  kitchen: 3.6,
  livingRoom: 18.2,
  roomOne: 11,
  bathroom: 4,
  garden: sqmCalculationForNonStandardSpaces(12.3, TYPE_OF_SPACES.GARDEN),
};

const B03: Apartment = {
  ...B_ONE,
  apartmentNumber: '03',
  floor: APARTMENT_GROUP.GROUND,
  entrance: 2.6,
  kitchen: 3.5,
  livingRoom: 18.2,
  roomOne: 10.8,
  bathroom: 3.7,
  garden: sqmCalculationForNonStandardSpaces(12.3, TYPE_OF_SPACES.GARDEN),
};

const B04: Apartment = {
  ...B_ONE,
  apartmentNumber: '04',
  floor: APARTMENT_GROUP.GROUND,
  entrance: 2.6,
  kitchen: 3.4,
  livingRoom: 17.9,
  roomOne: 11,
  bathroom: 3.8,
  garden: sqmCalculationForNonStandardSpaces(12.3, TYPE_OF_SPACES.GARDEN),
};

const B05: Apartment = {
  ...B_ONE,
  apartmentNumber: '05',
  floor: APARTMENT_GROUP.GROUND,
  entrance: 2.6,
  kitchen: 3.5,
  livingRoom: 18.2,
  roomOne: 10.8,
  bathroom: 3.8,
  garden: sqmCalculationForNonStandardSpaces(12.3, TYPE_OF_SPACES.GARDEN),
};

const B06: Apartment = {
  ...B_ONE,
  apartmentNumber: '06',
  floor: APARTMENT_GROUP.GROUND,
  entrance: 2.6,
  kitchen: 3.6,
  livingRoom: 18.2,
  roomOne: 10.8,
  bathroom: 3.8,
  garden: sqmCalculationForNonStandardSpaces(12.8, TYPE_OF_SPACES.GARDEN),
};

const B07: Apartment = {
  ...B_BP,
  apartmentNumber: '07',
  floor: APARTMENT_GROUP.GROUND,
  bp: true,
  livingRoom: 25.4,
};

const B08: Apartment = {
  ...B_BP,
  apartmentNumber: '08',
  floor: APARTMENT_GROUP.GROUND,
  bp: true,
  livingRoom: 19.6,
};
//#endregion

//#region C
const C01: Apartment = {
  ...C_BP,
  apartmentNumber: '01',
  floor: APARTMENT_GROUP.GROUND,
  bp: true,
  livingRoom: 25,
};

const C02: Apartment = {
  ...C_ONE,
  apartmentNumber: '02',
  floor: APARTMENT_GROUP.GROUND,
  entrance: 2.6,
  kitchen: 3.6,
  livingRoom: 18.2,
  roomOne: 10.8,
  bathroom: 3.8,
  garden: sqmCalculationForNonStandardSpaces(12.3, TYPE_OF_SPACES.GARDEN),
};

const C03: Apartment = {
  ...C_ONE,
  apartmentNumber: '03',
  floor: APARTMENT_GROUP.GROUND,
  entrance: 2.6,
  kitchen: 3.4,
  livingRoom: 17.9,
  roomOne: 11,
  bathroom: 3.8,
  garden: sqmCalculationForNonStandardSpaces(12.3, TYPE_OF_SPACES.GARDEN),
};

const C04: Apartment = {
  ...C_ONE,
  apartmentNumber: '04',
  floor: APARTMENT_GROUP.GROUND,
  entrance: 2.6,
  kitchen: 3.5,
  livingRoom: 18.2,
  roomOne: 11,
  bathroom: 3.8,
  garden: sqmCalculationForNonStandardSpaces(12.3, TYPE_OF_SPACES.GARDEN),
};

const C05: Apartment = {
  ...C_ONE,
  apartmentNumber: '05',
  floor: APARTMENT_GROUP.GROUND,
  entrance: 2.6,
  kitchen: 3.6,
  livingRoom: 17.9,
  roomOne: 10.8,
  bathroom: 3.8,
  garden: sqmCalculationForNonStandardSpaces(12.3, TYPE_OF_SPACES.GARDEN),
};

const C06: Apartment = {
  ...C_BP,
  apartmentNumber: '06',
  floor: APARTMENT_GROUP.GROUND,
  bp: true,
  livingRoom: 40.7,
};

const C07: Apartment = {
  ...C_BP,
  apartmentNumber: '07',
  floor: APARTMENT_GROUP.GROUND,
  bp: true,
  livingRoom: 24.8,
};

const C08: Apartment = {
  ...C_ONE,
  apartmentNumber: '08',
  floor: APARTMENT_GROUP.GROUND,
  entrance: 2.6,
  kitchen: 3.6,
  livingRoom: 18.2,
  roomOne: 10.8,
  bathroom: 3.8,
  garden: sqmCalculationForNonStandardSpaces(12.3, TYPE_OF_SPACES.GARDEN),
};

const C09: Apartment = {
  ...C_ONE,
  apartmentNumber: '09',
  floor: APARTMENT_GROUP.GROUND,
  entrance: 2.6,
  kitchen: 3.4,
  livingRoom: 17.9,
  roomOne: 11,
  bathroom: 3.8,
  garden: sqmCalculationForNonStandardSpaces(12.3, TYPE_OF_SPACES.GARDEN),
};

const C10: Apartment = {
  ...C_ONE,
  apartmentNumber: '10',
  floor: APARTMENT_GROUP.GROUND,
  entrance: 2.6,
  kitchen: 3.5,
  livingRoom: 18.2,
  roomOne: 11,
  bathroom: 3.8,
  garden: sqmCalculationForNonStandardSpaces(12.3, TYPE_OF_SPACES.GARDEN),
};

const C11: Apartment = {
  ...C_ONE,
  apartmentNumber: '11',
  floor: APARTMENT_GROUP.GROUND,
  entrance: 2.6,
  kitchen: 3.6,
  livingRoom: 18.2,
  roomOne: 10.8,
  bathroom: 3.8,
  garden: sqmCalculationForNonStandardSpaces(11.9, TYPE_OF_SPACES.GARDEN),
};

const C12: Apartment = {
  ...C_TWO,
  apartmentNumber: '12',
  floor: APARTMENT_GROUP.GROUND,
  entrance: 5.2,
  kitchen: 3.5,
  livingRoom: 10.8,
  roomOne: 9.9,
  roomTwo: 5.6,
  bathroom: 4.5,
  garden: sqmCalculationForNonStandardSpaces(58, TYPE_OF_SPACES.GARDEN),
};
//#endregion

//#endregion

//#region FLOORS

//#region A
const A12_23_34_45: Spaces = {
  entrance: 2.8,
  kitchen: 3.4,
  livingRoom: 9.7,
  roomOne: 9.1,
  bathroom: 4.5,
  balcony: sqmCalculationForNonStandardSpaces(9.6, TYPE_OF_SPACES.BALCONY),
};

const A12: Apartment = {
  apartmentNumber: '12',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...A_ONE,
  ...A12_23_34_45,
};

const A23: Apartment = {
  apartmentNumber: '23',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...A_ONE,
  ...A12_23_34_45,
};

const A34: Apartment = {
  apartmentNumber: '34',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...A_ONE,
  ...A12_23_34_45,
};

const A45: Apartment = {
  apartmentNumber: '45',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...A_ONE,
  ...A12_23_34_45,
};

const A13_24_35_46: Spaces = {
  entrance: 2.9,
  hallway: 4.2,
  kitchen: 3.6,
  livingRoom: 17.4,
  roomOne: 10.2,
  roomTwo: 10.8,
  bathroom: 4.5,
  wc: 1.8,
  storageRoom: 2,
  balcony: sqmCalculationForNonStandardSpaces(17.7, TYPE_OF_SPACES.BALCONY),
};

const A13: Apartment = {
  apartmentNumber: '13',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...A_TWO,
  ...A13_24_35_46,
};

const A24: Apartment = {
  apartmentNumber: '24',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...A_TWO,
  ...A13_24_35_46,
};

const A35: Apartment = {
  apartmentNumber: '35',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...A_TWO,
  ...A13_24_35_46,
};

const A46: Apartment = {
  apartmentNumber: '46',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...A_TWO,
  ...A13_24_35_46,
};

const A14_25_36_47: Spaces = {
  entrance: 2.7,
  kitchen: 3.6,
  livingRoom: 17.7,
  roomOne: 10.4,
  bathroom: 3.8,
  balcony: sqmCalculationForNonStandardSpaces(11.7, TYPE_OF_SPACES.BALCONY),
};

const A14: Apartment = {
  apartmentNumber: '14',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...A_ONE,
  ...A14_25_36_47,
};

const A25: Apartment = {
  apartmentNumber: '25',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...A_ONE,
  ...A14_25_36_47,
};

const A36: Apartment = {
  apartmentNumber: '36',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...A_ONE,
  ...A14_25_36_47,
};

const A47: Apartment = {
  apartmentNumber: '47',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...A_ONE,
  ...A14_25_36_47,
};

const A15_26_37_48: Spaces = {
  entrance: 2.7,
  kitchen: 3.5,
  livingRoom: 17.5,
  roomOne: 10.6,
  bathroom: 4,
  balcony: sqmCalculationForNonStandardSpaces(11.7, TYPE_OF_SPACES.BALCONY),
};

const A15: Apartment = {
  apartmentNumber: '15',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...A_ONE,
  ...A15_26_37_48,
};

const A26: Apartment = {
  apartmentNumber: '26',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...A_ONE,
  ...A15_26_37_48,
};

const A37: Apartment = {
  apartmentNumber: '37',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...A_ONE,
  ...A15_26_37_48,
};

const A48: Apartment = {
  apartmentNumber: '48',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...A_ONE,
  ...A15_26_37_48,
};

const A16_27_38_49: Spaces = {
  entrance: 3.6,
  kitchen: 3.5,
  livingRoom: 12.9,
  roomOne: 9.9,
  bathroom: 4.6,
  balcony: sqmCalculationForNonStandardSpaces(6.5, TYPE_OF_SPACES.BALCONY),
};

const A16: Apartment = {
  apartmentNumber: '16',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...A_ONE,
  ...A16_27_38_49,
};

const A27: Apartment = {
  apartmentNumber: '27',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...A_ONE,
  ...A16_27_38_49,
};

const A38: Apartment = {
  apartmentNumber: '38',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...A_ONE,
  ...A16_27_38_49,
};

const A49: Apartment = {
  apartmentNumber: '49',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...A_ONE,
  ...A16_27_38_49,
};

const A17_28_39_50: Spaces = {
  entrance: 3.6,
  kitchen: 3.5,
  livingRoom: 13.1,
  roomOne: 9.9,
  bathroom: 4.6,
  balcony: sqmCalculationForNonStandardSpaces(6.5, TYPE_OF_SPACES.BALCONY),
};

const A17: Apartment = {
  apartmentNumber: '17',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...A_ONE,
  ...A17_28_39_50,
};

const A28: Apartment = {
  apartmentNumber: '28',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...A_ONE,
  ...A17_28_39_50,
};

const A39: Apartment = {
  apartmentNumber: '39',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...A_ONE,
  ...A17_28_39_50,
};

const A50: Apartment = {
  apartmentNumber: '50',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...A_ONE,
  ...A17_28_39_50,
};

const A18_29_40_51: Spaces = {
  entrance: 2.7,
  kitchen: 3.6,
  livingRoom: 17.7,
  roomOne: 10.4,
  bathroom: 3.9,
  balcony: sqmCalculationForNonStandardSpaces(11.7, TYPE_OF_SPACES.BALCONY),
};

const A18: Apartment = {
  apartmentNumber: '18',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...A_ONE,
  ...A18_29_40_51,
};

const A29: Apartment = {
  apartmentNumber: '29',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...A_ONE,
  ...A18_29_40_51,
};

const A40: Apartment = {
  apartmentNumber: '40',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...A_ONE,
  ...A18_29_40_51,
};

const A51: Apartment = {
  apartmentNumber: '51',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...A_ONE,
  ...A18_29_40_51,
};

const A19_30_41_52: Spaces = {
  entrance: 2.7,
  kitchen: 3.6,
  livingRoom: 17.5,
  roomOne: 10.6,
  bathroom: 3.8,
  balcony: sqmCalculationForNonStandardSpaces(11.7, TYPE_OF_SPACES.BALCONY),
};

const A19: Apartment = {
  apartmentNumber: '19',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...A_ONE,
  ...A19_30_41_52,
};

const A30: Apartment = {
  apartmentNumber: '30',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...A_ONE,
  ...A19_30_41_52,
};

const A41: Apartment = {
  apartmentNumber: '41',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...A_ONE,
  ...A19_30_41_52,
};

const A52: Apartment = {
  apartmentNumber: '52',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...A_ONE,
  ...A19_30_41_52,
};

const A20_31_42_53: Spaces = {
  entrance: 2.7,
  hallway: 2.9,
  kitchen: 3.6,
  livingRoom: 17.7,
  roomOne: 10.5,
  roomTwo: 7.6,
  bathroom: 3.7,
  balcony: sqmCalculationForNonStandardSpaces(17.2, TYPE_OF_SPACES.BALCONY),
};

const A20: Apartment = {
  apartmentNumber: '20',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...A_TWO,
  ...A20_31_42_53,
};

const A31: Apartment = {
  apartmentNumber: '31',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...A_TWO,
  ...A20_31_42_53,
};

const A42: Apartment = {
  apartmentNumber: '42',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...A_TWO,
  ...A20_31_42_53,
};

const A53: Apartment = {
  apartmentNumber: '53',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...A_TWO,
  ...A20_31_42_53,
};

const A21_32_43_54: Spaces = {
  entrance: 3.2,
  kitchen: 4.7,
  livingRoom: 20.3,
  foyer: 2.2,
  roomOne: 10.5,
  roomTwo: 10,
  roomThree: 8.6,
  bathroom: 3.9,
  wc: 2.8,
  balcony: sqmCalculationForNonStandardSpaces(18.2, TYPE_OF_SPACES.BALCONY),
};

const A21: Apartment = {
  apartmentNumber: '21',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...A_THRE,
  ...A21_32_43_54,
};

const A32: Apartment = {
  apartmentNumber: '32',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...A_THRE,
  ...A21_32_43_54,
};

const A43: Apartment = {
  apartmentNumber: '43',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...A_THRE,
  ...A21_32_43_54,
};

const A54: Apartment = {
  apartmentNumber: '54',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...A_THRE,
  ...A21_32_43_54,
};

const A22_33_44_55: Spaces = {
  entrance: 5.2,
  kitchen: 3.5,
  livingRoom: 10.8,
  roomOne: 9.9,
  roomTwo: 5.6,
  bathroom: 4.5,
  balcony: sqmCalculationForNonStandardSpaces(8.2, TYPE_OF_SPACES.BALCONY),
};

const A22: Apartment = {
  apartmentNumber: '22',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...A_TWO,
  ...A22_33_44_55,
};

const A33: Apartment = {
  apartmentNumber: '33',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...A_TWO,
  ...A22_33_44_55,
};

const A44: Apartment = {
  apartmentNumber: '44',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...A_TWO,
  ...A22_33_44_55,
};

const A55: Apartment = {
  apartmentNumber: '55',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...A_TWO,
  ...A22_33_44_55,
};
//#endregion

//#region B
const B09_19_29_39: Spaces = {
  entrance: 3.1,
  kitchen: 3.9,
  livingRoom: 14.5,
  roomOne: 9.1,
  bathroom: 3.7,
  balcony: sqmCalculationForNonStandardSpaces(11.1, TYPE_OF_SPACES.BALCONY),
};

const B09: Apartment = {
  apartmentNumber: '09',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...B_ONE,
  ...B09_19_29_39,
};

const B19: Apartment = {
  apartmentNumber: '19',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...B_ONE,
  ...B09_19_29_39,
};

const B29: Apartment = {
  apartmentNumber: '29',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...B_ONE,
  ...B09_19_29_39,
};

const B39: Apartment = {
  apartmentNumber: '39',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...B_ONE,
  ...B09_19_29_39,
};

const B10_: Spaces = {
  entrance: 3.5,
  kitchen: 3.5,
  livingRoom: 13.1,
  bathroom: 4.4,
};

const B20_30_40: Spaces = {
  ...B10_,
  balcony: sqmCalculationForNonStandardSpaces(9.8, TYPE_OF_SPACES.BALCONY),
};

const B10: Apartment = {
  apartmentNumber: '10',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...B_STUDIO,
  ...B10_,
};

const B20: Apartment = {
  apartmentNumber: '20',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...B_STUDIO,
  ...B20_30_40,
};

const B30: Apartment = {
  apartmentNumber: '30',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...B_STUDIO,
  ...B20_30_40,
};

const B40: Apartment = {
  apartmentNumber: '40',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...B_STUDIO,
  ...B20_30_40,
};

const B11_21_31_41: Spaces = {
  entrance: 2.7,
  kitchen: 3.6,
  livingRoom: 18.2,
  roomOne: 10.8,
  bathroom: 3.9,
  balcony: sqmCalculationForNonStandardSpaces(11.7, TYPE_OF_SPACES.BALCONY),
};

const B11: Apartment = {
  apartmentNumber: '11',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...B_ONE,
  ...B11_21_31_41,
};

const B21: Apartment = {
  apartmentNumber: '21',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...B_ONE,
  ...B11_21_31_41,
};

const B31: Apartment = {
  apartmentNumber: '31',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...B_ONE,
  ...B11_21_31_41,
};

const B41: Apartment = {
  apartmentNumber: '41',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...B_ONE,
  ...B11_21_31_41,
};

const B12_22_32_42: Spaces = {
  entrance: 2.7,
  kitchen: 3.6,
  livingRoom: 18.2,
  roomOne: 11,
  bathroom: 4.9,
  balcony: sqmCalculationForNonStandardSpaces(11.7, TYPE_OF_SPACES.BALCONY),
};

const B12: Apartment = {
  apartmentNumber: '12',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...B_ONE,
  ...B12_22_32_42,
};

const B22: Apartment = {
  apartmentNumber: '22',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...B_ONE,
  ...B12_22_32_42,
};

const B32: Apartment = {
  apartmentNumber: '32',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...B_ONE,
  ...B12_22_32_42,
};

const B42: Apartment = {
  apartmentNumber: '42',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...B_ONE,
  ...B12_22_32_42,
};

const B13_23_33_43: Spaces = {
  entrance: 2.7,
  kitchen: 3.6,
  livingRoom: 18.2,
  roomOne: 11.6,
  bathroom: 3.7,
  balcony: sqmCalculationForNonStandardSpaces(11.1, TYPE_OF_SPACES.BALCONY),
};

const B13: Apartment = {
  apartmentNumber: '13',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...B_ONE,
  ...B13_23_33_43,
};

const B23: Apartment = {
  apartmentNumber: '23',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...B_ONE,
  ...B13_23_33_43,
};

const B33: Apartment = {
  apartmentNumber: '33',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...B_ONE,
  ...B13_23_33_43,
};

const B43: Apartment = {
  apartmentNumber: '43',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...B_ONE,
  ...B13_23_33_43,
};

const B14_24_34_44: Spaces = {
  entrance: 2.7,
  kitchen: 3.6,
  livingRoom: 17.9,
  roomOne: 11,
  bathroom: 3.9,
  balcony: sqmCalculationForNonStandardSpaces(11.7, TYPE_OF_SPACES.BALCONY),
};

const B14: Apartment = {
  apartmentNumber: '14',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...B_ONE,
  ...B14_24_34_44,
};

const B24: Apartment = {
  apartmentNumber: '24',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...B_ONE,
  ...B14_24_34_44,
};

const B34: Apartment = {
  apartmentNumber: '34',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...B_ONE,
  ...B14_24_34_44,
};

const B44: Apartment = {
  apartmentNumber: '44',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...B_ONE,
  ...B14_24_34_44,
};

const B15_25_35_45: Spaces = {
  entrance: 2.7,
  kitchen: 3.6,
  livingRoom: 18.2,
  roomOne: 10.8,
  bathroom: 3.9,
  balcony: sqmCalculationForNonStandardSpaces(11.7, TYPE_OF_SPACES.BALCONY),
};

const B15: Apartment = {
  apartmentNumber: '15',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...B_ONE,
  ...B15_25_35_45,
};

const B25: Apartment = {
  apartmentNumber: '25',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...B_ONE,
  ...B15_25_35_45,
};

const B35: Apartment = {
  apartmentNumber: '35',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...B_ONE,
  ...B15_25_35_45,
};

const B45: Apartment = {
  apartmentNumber: '45',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...B_ONE,
  ...B15_25_35_45,
};

const B16_26_36_46: Spaces = {
  entrance: 2.7,
  kitchen: 3.6,
  livingRoom: 18.2,
  roomOne: 10.8,
  bathroom: 3.9,
  balcony: sqmCalculationForNonStandardSpaces(12.2, TYPE_OF_SPACES.BALCONY),
};

const B16: Apartment = {
  apartmentNumber: '16',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...B_ONE,
  ...B16_26_36_46,
};

const B26: Apartment = {
  apartmentNumber: '26',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...B_ONE,
  ...B16_26_36_46,
};

const B36: Apartment = {
  apartmentNumber: '36',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...B_ONE,
  ...B16_26_36_46,
};

const B46: Apartment = {
  apartmentNumber: '46',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...B_ONE,
  ...B16_26_36_46,
};

const B17_27_37_47: Spaces = {
  entrance: 3.5,
  kitchen: 3.5,
  livingRoom: 13.1,
  bathroom: 4.4,
  balcony: sqmCalculationForNonStandardSpaces(8.6, TYPE_OF_SPACES.BALCONY),
};

const B17: Apartment = {
  apartmentNumber: '17',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...B_STUDIO,
  ...B17_27_37_47,
};

const B27: Apartment = {
  apartmentNumber: '27',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...B_STUDIO,
  ...B17_27_37_47,
};

const B37: Apartment = {
  apartmentNumber: '37',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...B_STUDIO,
  ...B17_27_37_47,
};

const B47: Apartment = {
  apartmentNumber: '47',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...B_STUDIO,
  ...B17_27_37_47,
};

const B18_28_38_48: Spaces = {
  entrance: 4.3,
  kitchen: 3.6,
  livingRoom: 8.4,
  roomOne: 9.1,
  bathroom: 3.8,
  balcony: sqmCalculationForNonStandardSpaces(9.1, TYPE_OF_SPACES.BALCONY),
};

const B18: Apartment = {
  apartmentNumber: '18',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...B_ONE,
  ...B18_28_38_48,
};

const B28: Apartment = {
  apartmentNumber: '28',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...B_ONE,
  ...B18_28_38_48,
};

const B38: Apartment = {
  apartmentNumber: '38',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...B_ONE,
  ...B18_28_38_48,
};

const B48: Apartment = {
  apartmentNumber: '48',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...B_ONE,
  ...B18_28_38_48,
};
//#endregion

//#region C
const C13_25_37_49: Spaces = {
  entrance: 3.6,
  kitchen: 3.5,
  livingRoom: 13.1,
  roomOne: 9.9,
  bathroom: 4.6,
  balcony: sqmCalculationForNonStandardSpaces(6.5, TYPE_OF_SPACES.BALCONY),
};

const C13: Apartment = {
  apartmentNumber: '13',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...C_ONE,
  ...C13_25_37_49,
};

const C25: Apartment = {
  apartmentNumber: '25',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...C_ONE,
  ...C13_25_37_49,
};

const C37: Apartment = {
  apartmentNumber: '37',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...C_ONE,
  ...C13_25_37_49,
};

const C49: Apartment = {
  apartmentNumber: '49',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...C_ONE,
  ...C13_25_37_49,
};

const C14_26_38_50: Spaces = {
  entrance: 2.7,
  kitchen: 3.6,
  livingRoom: 18.2,
  roomOne: 10.8,
  bathroom: 3.9,
  balcony: sqmCalculationForNonStandardSpaces(11.7, TYPE_OF_SPACES.BALCONY),
};

const C14: Apartment = {
  apartmentNumber: '14',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...C_ONE,
  ...C14_26_38_50,
};

const C26: Apartment = {
  apartmentNumber: '26',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...C_ONE,
  ...C14_26_38_50,
};

const C38: Apartment = {
  apartmentNumber: '38',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...C_ONE,
  ...C14_26_38_50,
};

const C50: Apartment = {
  apartmentNumber: '50',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...C_ONE,
  ...C14_26_38_50,
};

const C15_27_39_51: Spaces = {
  entrance: 2.7,
  kitchen: 3.6,
  livingRoom: 17.9,
  roomOne: 11,
  bathroom: 3.8,
  balcony: sqmCalculationForNonStandardSpaces(11.7, TYPE_OF_SPACES.BALCONY),
};

const C15: Apartment = {
  apartmentNumber: '15',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...C_ONE,
  ...C15_27_39_51,
};

const C27: Apartment = {
  apartmentNumber: '27',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...C_ONE,
  ...C15_27_39_51,
};

const C39: Apartment = {
  apartmentNumber: '39',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...C_ONE,
  ...C15_27_39_51,
};

const C51: Apartment = {
  apartmentNumber: '51',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...C_ONE,
  ...C15_27_39_51,
};

const C16_28_40_52: Spaces = {
  entrance: 2.7,
  kitchen: 3.6,
  livingRoom: 18.2,
  roomOne: 11,
  bathroom: 3.8,
  balcony: sqmCalculationForNonStandardSpaces(11.7, TYPE_OF_SPACES.BALCONY),
};

const C16: Apartment = {
  apartmentNumber: '16',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...C_ONE,
  ...C16_28_40_52,
};

const C28: Apartment = {
  apartmentNumber: '28',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...C_ONE,
  ...C16_28_40_52,
};

const C40: Apartment = {
  apartmentNumber: '40',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...C_ONE,
  ...C16_28_40_52,
};

const C52: Apartment = {
  apartmentNumber: '52',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...C_ONE,
  ...C16_28_40_52,
};

const C17_29_41_53: Spaces = {
  entrance: 2.7,
  kitchen: 3.6,
  livingRoom: 17.9,
  roomOne: 10.8,
  bathroom: 3.9,
  balcony: sqmCalculationForNonStandardSpaces(11.7, TYPE_OF_SPACES.BALCONY),
};

const C17: Apartment = {
  apartmentNumber: '17',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...C_ONE,
  ...C17_29_41_53,
};

const C29: Apartment = {
  apartmentNumber: '29',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...C_ONE,
  ...C17_29_41_53,
};

const C41: Apartment = {
  apartmentNumber: '41',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...C_ONE,
  ...C17_29_41_53,
};

const C53: Apartment = {
  apartmentNumber: '53',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...C_ONE,
  ...C17_29_41_53,
};

const C18_30_42_54: Spaces = {
  entrance: 5.2,
  kitchen: 3.5,
  livingRoom: 10.8,
  roomOne: 9.9,
  roomTwo: 5.6,
  bathroom: 4.5,
  balcony: sqmCalculationForNonStandardSpaces(9.6, TYPE_OF_SPACES.BALCONY),
};

const C18: Apartment = {
  apartmentNumber: '18',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...C_TWO,
  ...C18_30_42_54,
};

const C30: Apartment = {
  apartmentNumber: '30',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...C_TWO,
  ...C18_30_42_54,
};

const C42: Apartment = {
  apartmentNumber: '42',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...C_TWO,
  ...C18_30_42_54,
};

const C54: Apartment = {
  apartmentNumber: '54',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...C_TWO,
  ...C18_30_42_54,
};

const C19_31_43_55: Spaces = {
  entrance: 2.7,
  kitchen: 3.6,
  livingRoom: 17.9,
  roomOne: 10.8,
  bathroom: 3.9,
  balcony: sqmCalculationForNonStandardSpaces(9.5, TYPE_OF_SPACES.BALCONY),
};

const C19: Apartment = {
  apartmentNumber: '19',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...C_ONE,
  ...C19_31_43_55,
};

const C31: Apartment = {
  apartmentNumber: '31',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...C_ONE,
  ...C19_31_43_55,
};

const C43: Apartment = {
  apartmentNumber: '43',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...C_ONE,
  ...C19_31_43_55,
};

const C55: Apartment = {
  apartmentNumber: '55',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...C_ONE,
  ...C19_31_43_55,
};

const C20_32_44_56: Spaces = {
  entrance: 2.7,
  kitchen: 3.6,
  livingRoom: 18.2,
  roomOne: 10.8,
  bathroom: 3.9,
  balcony: sqmCalculationForNonStandardSpaces(11.7, TYPE_OF_SPACES.BALCONY),
};

const C20: Apartment = {
  apartmentNumber: '20',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...C_ONE,
  ...C20_32_44_56,
};

const C32: Apartment = {
  apartmentNumber: '32',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...C_ONE,
  ...C20_32_44_56,
};

const C44: Apartment = {
  apartmentNumber: '44',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...C_ONE,
  ...C20_32_44_56,
};

const C56: Apartment = {
  apartmentNumber: '56',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...C_ONE,
  ...C20_32_44_56,
};

const C21_33_45_57: Spaces = {
  entrance: 2.7,
  kitchen: 3.6,
  livingRoom: 17.9,
  roomOne: 11,
  bathroom: 3.8,
  balcony: sqmCalculationForNonStandardSpaces(11.7, TYPE_OF_SPACES.BALCONY),
};

const C21: Apartment = {
  apartmentNumber: '21',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...C_ONE,
  ...C21_33_45_57,
};

const C33: Apartment = {
  apartmentNumber: '33',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...C_ONE,
  ...C21_33_45_57,
};

const C45: Apartment = {
  apartmentNumber: '45',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...C_ONE,
  ...C21_33_45_57,
};

const C57: Apartment = {
  apartmentNumber: '57',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...C_ONE,
  ...C21_33_45_57,
};

const C22_34_46_58: Spaces = {
  entrance: 2.7,
  kitchen: 3.6,
  livingRoom: 18.2,
  roomOne: 11,
  bathroom: 3.8,
  balcony: sqmCalculationForNonStandardSpaces(11.7, TYPE_OF_SPACES.BALCONY),
};

const C22: Apartment = {
  apartmentNumber: '22',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...C_ONE,
  ...C22_34_46_58,
};

const C34: Apartment = {
  apartmentNumber: '34',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...C_ONE,
  ...C22_34_46_58,
};

const C46: Apartment = {
  apartmentNumber: '46',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...C_ONE,
  ...C22_34_46_58,
};

const C58: Apartment = {
  apartmentNumber: '58',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...C_ONE,
  ...C22_34_46_58,
};

const C23_35_47_59: Spaces = {
  entrance: 2.7,
  kitchen: 3.6,
  livingRoom: 18.2,
  roomOne: 10.8,
  bathroom: 3.9,
  balcony: sqmCalculationForNonStandardSpaces(11.7, TYPE_OF_SPACES.BALCONY),
};

const C23: Apartment = {
  apartmentNumber: '23',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...C_ONE,
  ...C23_35_47_59,
};

const C35: Apartment = {
  apartmentNumber: '35',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...C_ONE,
  ...C23_35_47_59,
};

const C47: Apartment = {
  apartmentNumber: '47',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...C_ONE,
  ...C23_35_47_59,
};

const C59: Apartment = {
  apartmentNumber: '59',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...C_ONE,
  ...C23_35_47_59,
};

const C24_36_48_60: Spaces = {
  entrance: 5.2,
  kitchen: 3.5,
  livingRoom: 10.8,
  roomOne: 9.9,
  roomTwo: 5.6,
  bathroom: 4.5,
  balcony: sqmCalculationForNonStandardSpaces(9.8, TYPE_OF_SPACES.BALCONY),
};

const C24: Apartment = {
  apartmentNumber: '24',
  floor: APARTMENT_GROUP.FLOOR_ONE,
  ...C_TWO,
  ...C24_36_48_60,
};

const C36: Apartment = {
  apartmentNumber: '36',
  floor: APARTMENT_GROUP.FLOOR_TWO,
  ...C_TWO,
  ...C24_36_48_60,
};

const C48: Apartment = {
  apartmentNumber: '48',
  floor: APARTMENT_GROUP.FLOOR_THREE,
  ...C_TWO,
  ...C24_36_48_60,
};

const C60: Apartment = {
  apartmentNumber: '60',
  floor: APARTMENT_GROUP.FLOOR_FOUR,
  ...C_TWO,
  ...C24_36_48_60,
};
//#endregion

//#endregion

//#region SUPERSTRUCTURE

//#region A
const A56: Apartment = {
  ...A_TWO,
  apartmentNumber: '56',
  floor: APARTMENT_GROUP.SUPERSTRUCTURE,
  entrance: 7,
  kitchen: 4.9,
  livingRoom: 14.5,
  roomOne: 8.9,
  roomTwo: 7.2,
  bathroom: 4.5,
  terrace: sqmCalculationForNonStandardSpaces(9.3, TYPE_OF_SPACES.BALCONY),
  terraceOpen: sqmCalculationForNonStandardSpaces(36.7, TYPE_OF_SPACES.TERRACE),
};

const A57: Apartment = {
  ...A_ONE,
  apartmentNumber: '57',
  floor: APARTMENT_GROUP.SUPERSTRUCTURE,
  entrance: 4.1,
  kitchen: 8.8,
  livingRoom: 10,
  roomOne: 9.7,
  bathroom: 4.1,
  terrace: sqmCalculationForNonStandardSpaces(15.9, TYPE_OF_SPACES.BALCONY),
  terraceOpen: sqmCalculationForNonStandardSpaces(68.9, TYPE_OF_SPACES.TERRACE),
};

const A58: Apartment = {
  ...A_ONE,
  apartmentNumber: '58',
  floor: APARTMENT_GROUP.SUPERSTRUCTURE,
  entrance: 4.2,
  kitchen: 8.8,
  livingRoom: 10,
  roomOne: 9.7,
  bathroom: 4.1,
  terrace: sqmCalculationForNonStandardSpaces(15.9, TYPE_OF_SPACES.BALCONY),
  terraceOpen: sqmCalculationForNonStandardSpaces(68.9, TYPE_OF_SPACES.TERRACE),
};

const A59: Apartment = {
  ...A_TWO,
  apartmentNumber: '59',
  floor: APARTMENT_GROUP.SUPERSTRUCTURE,
  entrance: 6.9,
  kitchen: 4.9,
  livingRoom: 14,
  roomOne: 9.6,
  roomTwo: 7.3,
  bathroom: 4.4,
  terrace: sqmCalculationForNonStandardSpaces(16.8, TYPE_OF_SPACES.BALCONY),
  terraceOpen: sqmCalculationForNonStandardSpaces(
    104.8,
    TYPE_OF_SPACES.TERRACE
  ),
};
//#endregion

//#region B
const B49: Apartment = {
  ...B_TWO,
  apartmentNumber: '49',
  floor: APARTMENT_GROUP.SUPERSTRUCTURE,
  entrance: 4.3,
  kitchen: 4.6,
  storageRoom: 3,
  livingRoom: 17,
  roomOne: 9.8,
  roomTwo: 7.8,
  bathroom: 4.3,
  terrace: sqmCalculationForNonStandardSpaces(16.1, TYPE_OF_SPACES.BALCONY),
  terraceOpen: sqmCalculationForNonStandardSpaces(
    120.3,
    TYPE_OF_SPACES.TERRACE
  ),
};

const B50: Apartment = {
  ...B_ONE,
  apartmentNumber: '50',
  floor: APARTMENT_GROUP.SUPERSTRUCTURE,
  entrance: 2.6,
  kitchen: 5.4,
  livingRoom: 14.8,
  roomOne: 10.7,
  bathroom: 4.4,
  terrace: sqmCalculationForNonStandardSpaces(8.6, TYPE_OF_SPACES.BALCONY),
  terraceOpen: sqmCalculationForNonStandardSpaces(6.5, TYPE_OF_SPACES.TERRACE),
};

const B51: Apartment = {
  ...B_TWO,
  apartmentNumber: '51',
  floor: APARTMENT_GROUP.SUPERSTRUCTURE,
  entrance: 4.5,
  hallway: 5.2,
  kitchen: 4.4,
  livingRoom: 16.3,
  roomOne: 9.8,
  roomTwo: 6.5,
  bathroom: 4.1,
  terrace: sqmCalculationForNonStandardSpaces(15.8, TYPE_OF_SPACES.BALCONY),
  terraceOpen: sqmCalculationForNonStandardSpaces(86.4, TYPE_OF_SPACES.TERRACE),
};
//#endregion

//#region C
const C61: Apartment = {
  ...C_ONE,
  apartmentNumber: '61',
  floor: APARTMENT_GROUP.SUPERSTRUCTURE,
  entrance: 4.2,
  kitchen: 8.8,
  livingRoom: 10,
  roomOne: 9.7,
  bathroom: 4.1,
  terrace: sqmCalculationForNonStandardSpaces(15.9, TYPE_OF_SPACES.BALCONY),
  terraceOpen: sqmCalculationForNonStandardSpaces(71, TYPE_OF_SPACES.TERRACE),
};

const C62: Apartment = {
  ...C_TWO,
  apartmentNumber: '62',
  floor: APARTMENT_GROUP.SUPERSTRUCTURE,
  entrance: 6.9,
  kitchen: 4.9,
  livingRoom: 14,
  roomOne: 9.6,
  roomTwo: 7.3,
  bathroom: 4.4,
  terrace: sqmCalculationForNonStandardSpaces(17, TYPE_OF_SPACES.BALCONY),
  terraceOpen: sqmCalculationForNonStandardSpaces(65.6, TYPE_OF_SPACES.TERRACE),
};

const C63: Apartment = {
  ...C_ONE,
  apartmentNumber: '63',
  floor: APARTMENT_GROUP.SUPERSTRUCTURE,
  entrance: 4.2,
  kitchen: 8.8,
  livingRoom: 10,
  roomOne: 9.7,
  bathroom: 4.1,
  terrace: sqmCalculationForNonStandardSpaces(15.9, TYPE_OF_SPACES.BALCONY),
  terraceOpen: sqmCalculationForNonStandardSpaces(71, TYPE_OF_SPACES.TERRACE),
};

const C64: Apartment = {
  ...C_TWO,
  apartmentNumber: '64',
  floor: APARTMENT_GROUP.SUPERSTRUCTURE,
  entrance: 6.9,
  kitchen: 4.9,
  livingRoom: 14,
  roomOne: 9.6,
  roomTwo: 7.3,
  bathroom: 4.4,
  terrace: sqmCalculationForNonStandardSpaces(17, TYPE_OF_SPACES.BALCONY),
  terraceOpen: sqmCalculationForNonStandardSpaces(65.6, TYPE_OF_SPACES.TERRACE),
};
//#endregion

//#endregion

const apartments: Apartment[] = [
  A01,
  A02,
  A03,
  A04,
  A05,
  A06,
  A07,
  A08,
  A09,
  A10,
  A11,
  B01,
  B02,
  B03,
  B04,
  B05,
  B06,
  B07,
  B08,
  C01,
  C02,
  C03,
  C04,
  C05,
  C06,
  C07,
  C08,
  C09,
  C10,
  C11,
  C12,
  A12,
  A13,
  A14,
  A15,
  A16,
  A17,
  A18,
  A19,
  A20,
  A21,
  A22,
  B09,
  B10,
  B11,
  B12,
  B13,
  B14,
  B15,
  B16,
  B17,
  B18,
  C13,
  C14,
  C15,
  C16,
  C17,
  C18,
  C19,
  C20,
  C21,
  C22,
  C23,
  C24,
  A23,
  A24,
  A25,
  A26,
  A27,
  A28,
  A29,
  A30,
  A31,
  A32,
  A33,
  B19,
  B20,
  B21,
  B22,
  B23,
  B24,
  B25,
  B26,
  B27,
  B28,
  C25,
  C26,
  C27,
  C28,
  C29,
  C30,
  C31,
  C32,
  C33,
  C34,
  C35,
  C36,
  A34,
  A35,
  A36,
  A37,
  A38,
  A39,
  A40,
  A41,
  A42,
  A43,
  A44,
  B29,
  B30,
  B31,
  B32,
  B33,
  B34,
  B35,
  B36,
  B37,
  B38,
  C37,
  C38,
  C39,
  C40,
  C41,
  C42,
  C43,
  C44,
  C45,
  C46,
  C47,
  C48,
  A45,
  A46,
  A47,
  A48,
  A49,
  A50,
  A51,
  A52,
  A53,
  A54,
  A55,
  B39,
  B40,
  B41,
  B42,
  B43,
  B44,
  B45,
  B46,
  B47,
  B48,
  C49,
  C50,
  C51,
  C52,
  C53,
  C54,
  C55,
  C56,
  C57,
  C58,
  C59,
  C60,
  A56,
  A57,
  A58,
  A59,
  B49,
  B50,
  B51,
  C61,
  C62,
  C63,
  C64,
];

// Utility function for finding the correct asset by apartment number
const findAsset = (
  list: { name: string; path: string }[],
  building: string,
  apartmentNumber: string
): string | undefined => {
  const regex = new RegExp(`${building}([0-9]+_)*${apartmentNumber}(_||$)`);
  return list.find(({ name }) => regex.test(name))?.path;
};

// Function to create an apartment object with dynamic assets
const createApartment = (apartment: Apartment) => ({
  ...apartment,
  apartmentImg: findAsset(
    apartmentsImgsList,
    apartment.building,
    apartment.apartmentNumber
  ),
  situationImg: findAsset(
    apartmentsSituationImgsList,
    apartment.building,
    apartment.apartmentNumber
  ),
  document: findAsset(
    apartmentsDocumentsList,
    apartment.building,
    apartment.apartmentNumber
  ),
});

// Function to load apartments from JSON and initialize the list
const loadApartments = async () => {
  try {
    // Create apartments with dynamic asset assignments
    const apartmentsData = apartments.map(createApartment);

    // Fetch and update availability
    const sheetsData = await fetchSheetData();
    updateApartmentAvailability(apartmentsData, sheetsData);

    return apartmentsData;
  } catch (error) {
    console.error('Error loading apartments:', error);
    return [];
  }
};

// Function to update apartment availability
const updateApartmentAvailability = (
  apartments: Apartment[],
  sheetsData: SheetsData
) => {
  const allData = [...(sheetsData.BrdaA || []), ...(sheetsData.BrdaB || [])];
  apartments.forEach((apartment) => {
    const matchedData = allData.find(
      (item) => item.id === apartment.building + apartment.apartmentNumber
    );
    if (matchedData) {
      apartment.availability = matchedData.status;
    }
  });
};

let APARTMENTS: Apartment[] = [];

// Initialize the apartments
const initializeInProgressList = async () => {
  if (APARTMENTS.length === 0) {
    APARTMENTS = await loadApartments();
  }

  console.log('Apartments initialized and availability updated.');
  return APARTMENTS;
};

export default initializeInProgressList;
